<script>
	//import {formatISO9075, isWithinInterval, parseISO} from 'date-fns'
	import lf from 'localforage'
	import {onMount} from 'svelte'
	import {get} from 'svelte/store'
	import Router from 'svelte-spa-router'
	import {wrap} from 'svelte-spa-router/wrap'
	import {location, pop, push} from 'svelte-spa-router'
	
	import {App, stApp} from './dbclib/App.js'

	import PageChannel from './routes/Channel.svelte'
	import PageChannelHistory from './routes/ChannelHistory.svelte'
	import PageChannelView from './routes/ChannelView.svelte'
	import PageChannels from './routes/Channels.svelte'
	import PageLogin from './routes/Login.svelte'
	import PageSettings from './routes/Settings.svelte'
	import PageTemplates from './routes/Templates.svelte'
	import PageTemplate from './routes/Template.svelte'
	import PageUserPassword from './routes/UserPassword.svelte'
	import PageUserRegister from './routes/UserRegister.svelte'
	import PageUsers from './routes/Users.svelte'



	let app = new App()
	//app.load()

	function loadState(page) {
		return wrap({
			component: page,
			conditions: [
				async (detail) => {
					if(!$stApp.user) $stApp = await app.load()
					return true
				}
			]
		})
	}

	const routes = {
			'/': loadState(PageLogin),
			'/channel': loadState(PageChannel),
			'/channel/view/:name': PageChannelView,
			'/channel/:uid': loadState(PageChannel),
			'/channel/:uid/history': loadState(PageChannelHistory),
			'/channels': loadState(PageChannels),
			'/settings': loadState(PageSettings),
			'/template': loadState(PageTemplate),
			'/template/:uid': loadState(PageTemplate),
			'/templates': loadState(PageTemplates),
			'/user/check/:key': loadState(PageUserPassword),
			'/user/register': loadState(PageUserRegister),
			'/users': loadState(PageUsers)
	}

</script>

<Router {routes}/>